import React from "react";
import { Link } from 'react-router-dom';
import './Digital Marketing.css';
  import Slide1  from "./Images/digitalmarketing_02.jpg";
  import { Helmet } from "react-helmet-async";
import {
    FaBullhorn, FaChartPie, FaSearch, FaCogs,
    FaEnvelopeOpenText, FaMobileAlt, FaUserFriends
} from "react-icons/fa";

const DigitalMarketing = () => {
    return (
        <div className="digital-marketing-container">


            <Helmet>
        <title>Digital Marketing Services - APTech Solution</title>
        <meta
          name="description"
          content="Boost your business online with APTech Solution's digital marketing services: SEO, social media marketing, paid ads, and content marketing."
        />
      </Helmet>

            {/* Hero Section */}
            <section className="digital-hero">
                <h1>Digital Marketing Services</h1>
                <p>Grow your brand presence, generate more leads, and boost conversions with our tailored digital strategies.</p>
                <img src={Slide1} alt="Digital Marketing Banner" />
            </section>

            {/* Services Section */}
            <section className="digital-services">
                <h2>What We Offer</h2>
                <div className="digital-services-grid">
                    <div className="digital-service-card bottom-border-card">
                        <FaSearch className="digital-icon" />
                        <h3>SEO Optimization</h3>
                        <p>Rank higher on search engines with expert on-page & off-page SEO.</p>
                    </div>
                    <div className="digital-service-card bottom-border-card">
                        <FaBullhorn className="digital-icon" />
                        <h3>Social Media Marketing</h3>
                        <p>Engage your audience with strategic campaigns across all platforms.</p>
                    </div>
                    <div className="digital-service-card bottom-border-card">
                        <FaEnvelopeOpenText className="digital-icon" />
                        <h3>Email Campaigns</h3>
                        <p>Reach and convert leads with highly personalized email marketing.</p>
                    </div>
                    <div className="digital-service-card bottom-border-card">
                        <FaChartPie className="digital-icon" />
                        <h3>PPC Advertising</h3>
                        <p>Maximize ROI with paid campaigns across Google, Facebook & more.</p>
                    </div>
                    <div className="digital-service-card bottom-border-card">
                        <FaMobileAlt className="digital-icon" />
                        <h3>Mobile Marketing</h3>
                        <p>Target users on mobile devices through SMS, in-app, and push marketing.</p>
                    </div>
                    <div className="digital-service-card bottom-border-card">
                        <FaUserFriends className="digital-icon" />
                        <h3>Influencer Marketing</h3>
                        <p>Leverage trusted voices to expand your brand’s reach authentically.</p>
                    </div>
                    <div className="digital-service-card bottom-border-card">
                        <FaBullhorn className="digital-icon" />
                        <h3>Affiliate Marketing</h3>
                        <p>Drive conversions using a network of affiliate partners and rewards.</p>
                    </div>
                    <div className="digital-service-card bottom-border-card">
                        <FaEnvelopeOpenText className="digital-icon" />
                        <h3>Content Marketing</h3>
                        <p>Create & distribute valuable content to attract and engage users.</p>
                    </div>
                    <div className="digital-service-card bottom-border-card">
                        <FaChartPie className="digital-icon" />
                        <h3>Video Marketing</h3>
                        <p>Promote your brand using engaging and interactive video content.</p>
                    </div>
                </div>
            </section>

            {/* Why Choose Us Section */}
            <section className="digital-why-choose">
                <h2>Why Choose Our Digital Marketing Services?</h2>
                <div className="digital-choose-row">
                    <div className="digital-choose-card gradient-border-card ">
                        <FaChartPie className="digital-icon" />
                        <h3>Customized Strategies</h3>
                        <p>Every campaign is designed uniquely to fit your business goals.</p>
                    </div>
                    <div className="digital-choose-card gradient-border-card ">
                        <FaSearch className="digital-icon" />
                        <h3>Data-Driven Results</h3>
                        <p>We rely on metrics, analytics, and KPIs to refine and deliver results.</p>
                    </div>
                    <div className="digital-choose-card gradient-border-card " >
                        <FaCogs className="digital-icon" />
                        <h3>End-to-End Management</h3>
                        <p>From planning to execution, we handle everything with transparency.</p>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="digital-cta">
                <h2>Ready to Grow Your Online Presence?</h2>
                <p>Let our experts craft your next digital marketing success story.</p>
                <Link to="/contact" state={{ scrollTo: "form" }}>
                    <p className="digital-cta-button">Get Started</p>
                </Link>

            </section>
        </div>
    );
};

export default DigitalMarketing;
